import { useState } from 'react';
import { startAuthentication } from '@simplewebauthn/browser';
import { toast } from 'sonner';
import { doorApi } from '@/api/door';

function getErrorMessage(error: unknown): string {
  if (error && typeof error === 'object' && 'response' in error) {
    const resp = (error as any).response?.data;
    return resp?.message || resp?.error || 'Неизвестная ошибка';
  }
  if (error instanceof Error) return error.message;
  return 'Неизвестная ошибка';
}

export function useDoorOpen() {
  const [isOpening, setIsOpening] = useState(false);

  const openDoor = async () => {
    setIsOpening(true);
    try {
      const options = await doorApi.getAuthenticationOptions();
      const credential = await startAuthentication({ optionsJSON: options });
      const result = await doorApi.openDoor(credential);

      window.open(result.url, '_blank');

      toast.success('Запрос отправлен');
    } catch (error: any) {
      if (error.name === 'NotAllowedError') {
        toast.error('Верификация отменена');
      } else {
        toast.error('Ошибка', { description: getErrorMessage(error) });
      }
    } finally {
      setIsOpening(false);
    }
  };

  return { openDoor, isOpening };
}
